import request from '@/utils/request'

export function getPolicyObj() {
    return request({
        url: 'cus/getPolicyObj/nnn123',
        method: 'get'
    })
}

export function upLoadToOss(data) {
    return request({
        url: 'https://static.xchengtech.cn/',
        method: 'post',
        headers: {

        },
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/oss.js